// extracted by mini-css-extract-plugin
export default {"renameIcon":"TagsModalContent-renameIcon-g4MBi","message":"TagsModalContent-message-jZkJe","result":"TagsModalContent-result-HDHRf"};